import banner from "../../../courses/module-1/img6.png";

const modulo6_pt = {
  courseId: "finanzas-personales",
  id: "modulo-6", // ⚠️ Mesmo ID
  title: "📘 MÓDULO 6: Consumo Responsável e Hábitos Financeiros",
  estimatedDuration: "2 horas",
  format: "Leitura + autoobservação + desafio escrito",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos do módulo",
      content: [
        "Identificar como e por que tomamos decisões de consumo sem pensar.",
        "Reconhecer o efeito acumulado dos gastos pequenos e repetitivos.",
        "Desenvolver hábitos financeiros conscientes e sustentáveis.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Leitura principal",
      title: "📖 Leitura principal: O que é consumo responsável?",
      content: [
        "Consumir de forma responsável não é deixar de comprar, mas fazer isso com consciência e intenção.",
        "Trata-se de se perguntar:",
        {
          type: "list",
          items: [
            "Eu realmente preciso disso?",
            "Posso pagar sem me endividar ou prejudicar minhas metas?",
            "Estou comprando por impulso, pressão ou tédio?",
          ],
        },
        "Consumir com intenção = cuidar do seu dinheiro e das suas decisões.",
      ],
    },
    {
      id: "razones",
      navLabel: "Razões",
      title: "🚩 Razões para adotar o consumo consciente",
      content: [
        {
          type: "list",
          items: [
            "Evita o arrependimento pós-compra",
            "Reduz desperdícios e compras por modinha",
            "Fortalece seu controle financeiro sem a sensação de “privação”",
            "Ajuda a tomar decisões alinhadas com seus valores",
          ],
        },
      ],
    },
    {
      id: "gasto-hormiga",
      navLabel: "Gasto formiga",
      title: "💸 O impacto do gasto formiga",
      content: [
        "Os gastos formiga são pequenos gastos diários que parecem inofensivos, mas se acumulam silenciosamente. Exemplos:",
        {
          type: "table",
          headers: [
            "Gasto diário",
            "Gasto mensal aprox.",
            "Gasto anual aprox.",
          ],
          rows: [
            ["Café de R$ 10", "R$ 200", "R$ 2.400"],
            ["Snacks de R$ 8", "R$ 160", "R$ 1.920"],
            ["Apps de delivery", "R$ 60 por semana", "R$ 3.000+"],
          ],
        },
        "Exercício rápido:",
        {
          type: "list",
          items: [
            "Anote durante 3 dias TUDO o que você gasta sem pensar.",
            "Ao final, some e identifique o que poderia reduzir sem sofrimento.",
          ],
        },
      ],
    },
    {
      id: "tecnicas",
      navLabel: "Técnicas",
      title: "🛠 Técnicas para melhorar seus hábitos com o dinheiro",
      content: [
        {
          type: "orderedList",
          items: [
            "Regra dos 10 segundos: Antes de comprar, conte até 10 e pergunte se realmente precisa.",
            "Lista de espera de 72 horas: Se não é urgente, espere 3 dias. Se ainda quiser, compre com intenção.",
            "Orçamento de “mimos”: Não se trata de eliminar prazeres, mas de definir um limite seguro.",
            "Apps de rastreamento de hábitos: TryHabit, Tally, Google Sheets simples.",
            "Técnica do lembrete visual: Coloque sua meta de economia escrita dentro da carteira.",
          ],
        },
      ],
    },
    {
      id: "herramienta",
      navLabel: "Ferramenta",
      title:
        "🧩 Ferramenta do módulo: planilha de acompanhamento de hábitos financeiros",
      content: [
        "Para acompanhar este módulo, use uma planilha semanal onde você anotará:",
        {
          type: "list",
          items: [
            "Gasto evitado",
            "Motivo do impulso",
            "Emoção presente",
            "Decisão final (comprou ou não?)",
            "O que você aprendeu sobre si naquele dia?",
          ],
        },
        "🔗 Pode ser feita no papel, no Google Sheets ou em qualquer app de notas.",
        "O mesmo formato funciona para hábitos positivos, como registrar gastos, economizar ou reduzir o uso da cartão.",
      ],
    },
    {
      id: "ejemplo",
      navLabel: "Exemplo real",
      title: "💬 Exemplo real",
      content: [
        "🎓 Alondra, 19 anos, do Guarujá-SP, percebeu que gastava R$ 150 por semana em Uber quando poderia caminhar ou pegar ônibus.",
        "Ela decidiu fazer o experimento de uma “semana sem Uber desnecessário” e conseguiu economizar R$ 600 naquele mês.",
        "Com o dinheiro, pagou o domínio do seu site para lançar um portfólio criativo como designer.",
        "“Não era deixar de viver, era escolher melhor em que gastava o que tanto me custa ganhar.”",
      ],
    },
    {
      id: "maslow",
      navLabel: "Maslow",
      title: "🔺 Extra: A Pirâmide de Maslow e nossas decisões de consumo",
      content: [
        {
          type: "paragraph",
          text: "📌 O que é a pirâmide de Maslow?",
        },
        "É um modelo psicológico que representa as necessidades humanas organizadas em níveis, das mais básicas às mais complexas. Ajuda a entender por que fazemos o que fazemos, inclusive como gastamos dinheiro.",
        {
          type: "table",
          headers: [
            "Nível",
            "Necessidade humana",
            "Exemplos ligados ao consumo",
          ],
          rows: [
            ["1. Fisiológicas", "Comida, água, descanso", "Comer, transporte"],
            [
              "2. Segurança",
              "Estabilidade, saúde, dinheiro",
              "Poupança, aluguel, seguros",
            ],
            [
              "3. Sociais",
              "Pertença, amigos",
              "Roupas da moda, saídas, gadgets populares",
            ],
            [
              "4. Estima / Reconhecimento",
              "Prestígio, imagem, autoestima",
              "Acessórios, tecnologia cara, estilo pessoal",
            ],
            [
              "5. Autorrealização",
              "Propósito, liberdade, realização",
              "Educação, empreendedorismo, experiências",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🤔 O que isso tem a ver com suas finanças?",
        },
        "Tudo!",
        "Muitas vezes não gastamos por necessidade real, mas por:",
        {
          type: "list",
          items: [
            "Querer “pertencer” (nível 3)",
            "Mostrar sucesso ou autoestima (nível 4)",
            "Compensar emoções e inseguranças",
          ],
        },
        {
          type: "paragraph",
          text: "💡 O consumo impulsivo muitas vezes tenta preencher vazios dos níveis superiores sem que os básicos estejam bem cuidados.",
        },
        {
          type: "paragraph",
          text: "🧠 Como usar Maslow para consumir melhor",
        },
        {
          type: "paragraph",
          text: "Antes de comprar, pergunte:",
        },
        {
          type: "list",
          items: [
            "“Estou atendendo uma necessidade real ou só tentando me sentir melhor por alguns minutos?”",
          ],
        },
        {
          type: "paragraph",
          text: "Dê preferência a investimentos que te aproximem da autorrealização (nível 5):",
        },
        {
          type: "list",
          items: [
            "Aprender algo novo",
            "Criar",
            "Empreender",
            "Cuidar da saúde mental ou financeira",
          ],
        },
        {
          type: "paragraph",
          text: "💬 Reflexão: “Consumir por necessidade te liberta. Consumir por vazio te aprisiona.”",
        },
      ],
    },
    {
      id: "evaluacion",
      navLabel: "Desafio final",
      title: "📝 Avaliação: desafio final do curso",
      content: [
        'Desafio escrito: "Minha semana sem gastos desnecessários" (em caderno ou documento)',
        "O que você deve fazer?",
        "Durante 7 dias:",
        {
          type: "orderedList",
          items: [
            "Observe seus hábitos de consumo diários.",
            "Tente evitar pelo menos um gasto desnecessário por dia.",
            "Registre suas decisões (em papel, app ou nota de voz).",
            "Reflita:",
          ],
        },
        {
          type: "list",
          items: [
            "O que você aprendeu sobre si mesmo?",
            "Qual foi o gasto mais difícil de evitar?",
            "Você se sentiu privado ou empoderado?",
            "Quanto conseguiu economizar?",
          ],
        },
      ],
    },
    {
      id: "bibliografia",
      navLabel: "Bibliografia",
      title: "📚 Bibliografia recomendada",
      content: [
        "Daniel Kahneman – “Rápido e Devagar: Duas Formas de Pensar”",
        "Blog: “Minimalismo Financeiro”",
        "Podcast: “Neurona Financeira”",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: ["“Não se trata de gastar menos. Se trata de gastar melhor.”"],
    },
  ],
};

export default modulo6_pt;
